import { useQuery } from '@apollo/client';
import { useResource } from '@landsbankinn/l16n';
import { Segment } from '@landsbankinn/ui';
import { LandsbankinnContext } from '@landsbankinn/utils';
import React, { useContext } from 'react';
import { Funds } from '../components/markets/funds/Funds';
import fundRes from '../components/markets/funds/Funds.res';
import res from '../components/markets/shared/markets-disclaimer/MarketsDisclaimer.res';
import { FETCH_FUNDS } from '../graphql/fetchFunds';

export default function FundsContainer() {
  const { client } = useContext(LandsbankinnContext);
  const { data } = useQuery(FETCH_FUNDS, {
    client,
    variables: { first: 100 },
  });
  const { r, locale } = useResource();
  return (
    <Segment>
      <Funds
        funds={data}
        fundBuyUrl={() =>
          'https://netbanki.landsbankinn.is/Securities/Overview/Overview.aspx#/funds/market'
        }
        stockBuyUrl={() =>
          'https://netbanki.landsbankinn.is/Securities/Overview/Overview.aspx#/stocks/market'
        }
        fundDetailPrefix={locale == 'is' ? '/sjodir/' : '/en/mutual-funds/'}
        disclaimerText={r(res.disclaimer['landsbref'])}
        einkabrefDisclaimer={r(fundRes.einkabrefDisclaimer['landsbref'])}
        foreignCurrencyDisclaimer={r(
          fundRes.foreignCurrencyDisclaimer['landsbref'],
        )}
        fundsDisclaimer={r(fundRes.fundsDisclaimer3['landsbref'])}
      />
    </Segment>
  );
}
